// extracted by mini-css-extract-plugin
module.exports = {"content":"Hint_content__jWztG","text-container":"Hint_text-container__QteE3","description":"Hint_description__7lhuJ","close-container":"Hint_close-container__fLb9K"};